@let isChecked = this.currentState === VbUiCheckboxState.CHECKED;
@let isMixed = this.currentState === VbUiCheckboxState.MIXED;

<label #wrapperLabel layout="row" layout-wrap="false" [attr.tabindex]="disableTabFocus || disabled ? -1 : 0">
	<button type="button" role="checkbox" tabindex="-1" flex [attr.aria-checked]="ariaCheckedState" [attr.aria-label]="accessibilityLabel" class="button" [class.active]="isChecked" [class.disabled]="disabled" [disabled]="disabled" (blur)="onTouched()" (click)="onClick()">
		@if (isChecked) {
			<span class="icon glyphicons ok_2"></span>
		} @else if (mixedStateEnabled && isMixed) {
			<div class="theme-accent-bg height-full mixed"></div>
		}
	</button>
	<div class="label" flex="fill" flex-align-self="center">
		<ng-content></ng-content>
	</div>
</label>